<template>
  <f7-page>
    <f7-navbar title="Page Not Found" back-link="Back"></f7-navbar>
    <f7-block class="text-center">
      <div class="not-found-container">
        <div class="not-found-code">404</div>
        <div class="not-found-title">Page Not Found</div>
        <p class="not-found-text">Sorry, the page you are looking for doesn't exist or has been moved.</p>
        <f7-button fill color="primary" href="/">
          Go to Home Page
        </f7-button>
      </div>
    </f7-block>
  </f7-page>
</template>

<script setup>
// No additional logic needed for this component
</script>

<style scoped>
.not-found-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 2rem auto;
  max-width: 480px;
}

.not-found-code {
  font-size: 6rem;
  font-weight: 700;
  color: var(--f7-theme-color);
  margin-bottom: 1rem;
}

.not-found-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
}

.not-found-text {
  color: var(--f7-block-text-color);
  margin-bottom: 2rem;
  text-align: center;
}
</style>
